const shot = (id, w = 1600) =>
  `https://images.unsplash.com/${id}?auto=format&fit=crop&w=${w}&q=80`;

export const photos = {
  hero: shot('photo-1534438327276-14e5300c3a48', 1800),
  gym: shot('photo-1517836357463-d25dfeac3438', 1400),
  lift: shot('photo-1571019614242-c5c5dee9f50b', 1200),
  hiit: shot('photo-1518611012118-696072aa579a', 1200),
  yoga: shot('photo-1544367567-0f2fcb009e0b', 1200),
  bowl: shot('photo-1546069901-ba9599a7e63c', 1200),
  chicken: shot('photo-1532550907401-a500c9a57435', 1200),
  meal: shot('photo-1490645935967-10de6ba17061', 1600),
  market: shot('photo-1542838132-92c53300491e', 1600),
  run: shot('photo-1552674605-db6ffd4facb5', 2000),
  fresh: shot('photo-1498837167922-ddd27525d352', 1200),
};
